import { graphql } from '@/generated/gql';

export const TEAM_QUERY = graphql(/* GraphQL */ `
  query TeamManagementTeam($teamId: UUID!) {
    Pasa: pasaGraphql {
      team(teamId: $teamId) {
        id
        name
        users {
          id
        }
        teams {
          id
        }
        scopes {
          id
        }
      }
    }
  }
`);

export const UPSERT_TEAM_MUTATION = graphql(/* GraphQL */ `
  mutation TeamManagementUpsertTeam($input: PasaUpsertTeamInput!) {
    Pasa: pasaGraphql {
      upsertTeam(input: $input) {
        id
        name
        scopeIds
        userMemberIds
        teamMemberIds
      }
    }
  }
`);

export const DELETE_TEAM_MUTATION = graphql(/* GraphQL */ `
  mutation TeamManagementDeleteTeam($teamId: UUID!) {
    Pasa: pasaGraphql {
      deleteTeam(teamId: $teamId) {
        id
      }
    }
  }
`);
